import styles from "./TopNav.module.css";

import {
    FaBars,
    FaUserCircle,
} from "react-icons/fa";

const TopNav = ({
    user,
    onMenuClick,
}) => {

    return (

        <header className={styles.container}>

            <button
                type="button"
                className={styles.menuButton}
                onClick={onMenuClick}
                aria-label="باز کردن منو"
            >
                <FaBars />
            </button>

            <div className={styles.brand}>

                <h1 className={styles.title}>
                    اتویاد
                </h1>

                <span className={styles.subtitle}>
                    مدیریت سرویس و هزینه های خودرو
                </span>

            </div>

            <div className={styles.profile}>

                {
                    user?.imageUrl
                        ?
                        <img
                            src={user.imageUrl}
                            alt={user.fullName}
                            className={styles.avatar}
                        />
                        :
                        <FaUserCircle
                            className={styles.avatarPlaceholder}
                        />
                }

                <span className={styles.userName}>
                    {user?.fullName ?? ""}
                </span>

            </div>

        </header>

    );

};

export default TopNav;